// src/services/p2pService.js

// ИСПРАВЛЕНО: используем тот же URL что и в financialService
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

class P2pService {
    constructor() {
        this.token = localStorage.getItem('auth_token');
    }

    getHeaders() {
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`,
            'Accept': 'application/json',
        };
    }

    getMultipartHeaders() {
        return {
            'Authorization': `Bearer ${this.token}`,
            'Accept': 'application/json',
            // НЕ устанавливаем Content-Type для multipart/form-data
            // браузер сам установит правильный с boundary
        };
    }

    updateToken() {
        this.token = localStorage.getItem('auth_token');
    }

    // Улучшенная обработка ответов
    async handleResponse(response) {
        const data = await response.json();

        // Логирование для отладки
        console.log(`📥 P2P Response [${response.status}]:`, data);

        // Всегда возвращаем данные, даже при ошибках
        // Это позволяет фронтенду обрабатывать детализированные ошибки
        return data;
    }

    // ==================== ОБЪЯВЛЕНИЯ ====================

    /**
     * Получить список всех объявлений
     * @param {Object} params - Параметры фильтрации
     * @param {string} params.currency - Валюта (RUB, USD)
     * @param {string} params.type - Тип (all, sell, buy)
     */
    async getOffers(params = {}) {
        this.updateToken();

        try {
            const queryParams = new URLSearchParams();
            if (params.currency) queryParams.append('currency', params.currency);
            if (params.type && params.type !== 'all') queryParams.append('type', params.type);

            console.log('📤 P2P Request: GET /p2p/offers', { params });

            const response = await fetch(
                `${API_BASE_URL}/p2p/offers?${queryParams}`,
                {
                    headers: this.getHeaders(),
                }
            );

            return await this.handleResponse(response);
        } catch (error) {
            console.error('❌ Get offers error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером',
                error: error.message
            };
        }
    }

    /**
     * Получить мои объявления
     */
    async getMyOffers() {
        this.updateToken();

        try {
            console.log('📤 P2P Request: GET /p2p/my-offers');

            const response = await fetch(
                `${API_BASE_URL}/p2p/my-offers`,
                {
                    headers: this.getHeaders(),
                }
            );

            return await this.handleResponse(response);
        } catch (error) {
            console.error('❌ Get my offers error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером',
                error: error.message
            };
        }
    }

    /**
     * Создать объявление
     * @param {Object} data - Данные объявления
     * @param {string} data.type - Тип (sell, buy)
     * @param {number} data.amount - Сумма
     * @param {string} data.currency - Валюта
     * @param {number} data.min_amount - Минимальная сумма (необязательно)
     * @param {number} data.max_amount - Максимальная сумма (необязательно)
     * @param {string} data.terms - Условия сделки (необязательно)
     */
    async createOffer(data) {
        this.updateToken();

        try {
            console.log('📤 P2P Request: POST /p2p/offers', data);

            const response = await fetch(
                `${API_BASE_URL}/p2p/offers`,
                {
                    method: 'POST',
                    headers: this.getHeaders(),
                    body: JSON.stringify(data),
                }
            );

            return await this.handleResponse(response);
        } catch (error) {
            console.error('❌ Create offer error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером',
                error: error.message
            };
        }
    }

    /**
     * Отменить объявление
     * @param {number} offerId - ID объявления
     */
    async cancelOffer(offerId) {
        this.updateToken();

        try {
            console.log('📤 P2P Request: POST /p2p/offers/{id}/cancel', { offerId });

            const response = await fetch(
                `${API_BASE_URL}/p2p/offers/${offerId}/cancel`,
                {
                    method: 'POST',
                    headers: this.getHeaders(),
                }
            );

            return await this.handleResponse(response);
        } catch (error) {
            console.error('❌ Cancel offer error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером',
                error: error.message
            };
        }
    }

    // ==================== СДЕЛКИ ====================

    /**
     * Получить мои сделки
     */
    async getMyTransactions() {
        this.updateToken();

        try {
            console.log('📤 P2P Request: GET /p2p/my-transactions');

            const response = await fetch(
                `${API_BASE_URL}/p2p/my-transactions`,
                {
                    headers: this.getHeaders(),
                }
            );

            return await this.handleResponse(response);
        } catch (error) {
            console.error('❌ Get my transactions error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером',
                error: error.message
            };
        }
    }

    /**
     * Создать сделку
     * @param {Object} data - Данные сделки
     * @param {number} data.offer_id - ID объявления
     * @param {number} data.amount - Сумма сделки
     */
    async createTransaction(data) {
        this.updateToken();

        try {
            console.log('📤 P2P Request: POST /p2p/transactions', data);

            const response = await fetch(
                `${API_BASE_URL}/p2p/transactions`,
                {
                    method: 'POST',
                    headers: this.getHeaders(),
                    body: JSON.stringify(data),
                }
            );

            return await this.handleResponse(response);
        } catch (error) {
            console.error('❌ Create transaction error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером',
                error: error.message
            };
        }
    }

    /**
     * Подтвердить оплату (загрузить чек)
     * @param {number} transactionId - ID сделки
     * @param {File} file - Файл чека
     */
    async confirmPayment(transactionId, file) {
        this.updateToken();

        try {
            console.log('📤 P2P Request: POST /p2p/transactions/{id}/confirm-payment', {
                transactionId,
                fileName: file.name,
                fileSize: file.size
            });

            const formData = new FormData();
            formData.append('payment_proof', file);

            const response = await fetch(
                `${API_BASE_URL}/p2p/transactions/${transactionId}/confirm-payment`,
                {
                    method: 'POST',
                    headers: this.getMultipartHeaders(),
                    body: formData,
                }
            );

            return await this.handleResponse(response);
        } catch (error) {
            console.error('❌ Confirm payment error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером',
                error: error.message
            };
        }
    }

    /**
     * Завершить сделку (подтвердить получение средств)
     * @param {number} transactionId - ID сделки
     */
    async completeTransaction(transactionId) {
        this.updateToken();

        try {
            console.log('📤 P2P Request: POST /p2p/transactions/{id}/complete', { transactionId });

            const response = await fetch(
                `${API_BASE_URL}/p2p/transactions/${transactionId}/complete`,
                {
                    method: 'POST',
                    headers: this.getHeaders(),
                }
            );

            return await this.handleResponse(response);
        } catch (error) {
            console.error('❌ Complete transaction error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером',
                error: error.message
            };
        }
    }

    /**
     * Отменить сделку
     * @param {number} transactionId - ID сделки
     * @param {string} reason - Причина отмены
     */
    async cancelTransaction(transactionId, reason) {
        this.updateToken();

        try {
            console.log('📤 P2P Request: POST /p2p/transactions/{id}/cancel', {
                transactionId,
                reason
            });

            const response = await fetch(
                `${API_BASE_URL}/p2p/transactions/${transactionId}/cancel`,
                {
                    method: 'POST',
                    headers: this.getHeaders(),
                    body: JSON.stringify({ reason }),
                }
            );

            return await this.handleResponse(response);
        } catch (error) {
            console.error('❌ Cancel transaction error:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером',
                error: error.message
            };
        }
    }
}

// Экспортируем singleton экземпляр
export const p2pService = new P2pService();

// Также экспортируем класс для возможности создания новых экземпляров
export default P2pService;
